import { navigationConfig } from './feature/navigation.config';
import { cmsConfig } from '@config/feature/cms.config';
import { iconConfig } from '@config/feature/icon.config';
import { googleMapsConfig } from '@config/feature/google-maps.config';
import { languageConfig } from '@config/feature/language.config';

export const appConfig = {
  cms: cmsConfig,
  googleMaps: googleMapsConfig,
  icons: iconConfig,
  language: languageConfig,
  navigation: navigationConfig
};
